var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#813cf3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.042 6.858 8.029 4.59v9.014l-8.029-4.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.5 20.415 7.959-4.575v-8.953l-7.959 4.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.541 11.01 8.03 4.589v-9.009l-8.03-4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.042 25.41 8.029 4.59v-9.043l-8.029-4.589z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/terraform.4498276824db8c78b8971511fd1d297e.svg";
export { ForwardRef as ReactComponent };